<template>

  <v-snackbar
      v-model="announcement"
      :timeout="-1"
      color="#b7b6b6"
      fixed
      left
      shaped
      bottom
  >
        <v-btn
            icon
            dark
            @click="announcement = false"
        >
            <v-icon height="2px">mdi-close</v-icon>
        </v-btn>
        <span class="announcement-text">{{language =='Ελληνικά'? 'Ανακοίνωση' : 'Announcement'}}</span>
        <v-btn
          color="red"
          class="ml-5"
          text
          @click="goToArticle"
        >
          {{language =='Ελληνικά'? 'Δες εδώ!' : 'Read here!'}}
        </v-btn>
  </v-snackbar>
  <!-- <v-fab-transition v-if="announcement">
      <v-tooltip max-width="70vw" disabled top :value="announcement">
          <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  color="#f11a23f0"
                  dark
                  fixed
                  bottom
                  left
                  fab
                  @click="goToArticle"
              >
                  <v-icon>announcement </v-icon>
              </v-btn>
          </template>
          <span class="announcement-text">{{title}}</span>
      </v-tooltip>
  </v-fab-transition> -->
</template>

<script>
  import restApi from "@/rest-api";
  export default {
    props: {
        language: String
    },
    data() { 
        return {
            id: 0,
            announcement: false,
            title: 'Ανακοίνωση'
        }
    },
    watch: {
      '$route.query.articleId': function (id) {
        if(id != undefined && id != 0 && !this.announcement){
          this.announcement = false
        } else {
          this.announcement = true
        }
      }
    },
    created() {
      this.fetchArticles();
    },
    methods: {
      fetchArticles() {
        var search = `/article/all`;
        restApi
        .get(search)
        .then(response => {
              this.isAnnouncement(response.data)
        })
        .catch((error) => {
            console.log(error);
        });
      },
      goToArticle() {
        this.$router.push({name: 'Article', query: { articleId: this.id }});
      },
      isAnnouncement(articles) {
          articles.forEach(article => {
              if(article.isAnouncement) {
                  this.announcement = true
                  this.id=article.id
                  this.title = article.announcementTitle
              }
          })
      }
    }
  }
</script>
<style lang="scss" scoped>
    @media only screen and (min-width: 600px){
        .v-btn{ 
            width: 80px !important;
            height: 80px !important;
            font-weight: bold;
        }
        .v-icon{ 
            font-size: 35px!important;
        }
        .announcement-text {
          font-size: 20px;
          max-width: 20vw;
        }
    }
</style>    